<template>
  <div
    class="wallet-information-page"
    :class="$vuetify.theme.dark ? 'wallet-information--dark' : 'wallet-information--light'"
  >
    <v-container fluid class="wallet-information-container">
      <div class="wallet-information-header">
        <div>
          <p>Manage your deposit &amp; withdrawal methods</p>
        </div>
        <DropdownMenu />
      </div>

      <BankInfoAllTabs />
    </v-container>
  </div>
</template>

<script>
import BankInfoAllTabs from "@/components/PagesComponents/BankInformation/BankInfoAllTabs";
import DropdownMenu from "@/components/PagesComponents/BankInformation/DropdownMenu";
export default {
  components: {
    BankInfoAllTabs,
    DropdownMenu,
  },
};
</script>

<style scoped>
.wallet-information-page {
  --wallet-accent: #d99a00;
  --wallet-accent-soft: rgba(217, 154, 0, 0.12);
  --wallet-bg: #f7f8fa;
  --wallet-panel: #ffffff;
  --wallet-surface: #f4f5f7;
  --wallet-border: #dfe2e6;
  --wallet-text: #171a1f;
  --wallet-muted: #626973;
  height: calc(100vh - 64px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: var(--wallet-bg);
  color: var(--wallet-text);
}

.wallet-information--dark {
  --wallet-accent: #ffc400;
  --wallet-accent-soft: rgba(255, 196, 0, 0.12);
  --wallet-bg: #030b13;
  --wallet-panel: #07111b;
  --wallet-surface: #0b1621;
  --wallet-border: #293026;
  --wallet-text: #f4f5f7;
  --wallet-muted: #aeb6c0;
}

.wallet-information-container {
  max-width: 1680px;
  padding: 24px 28px 40px;
}

.wallet-information-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 12px;
}

.wallet-information-header h1 {
  margin: 0;
  color: var(--wallet-text);
  font-size: 25px;
  line-height: 1.25;
}
.wallet-information-header p {
  margin: 0;
  color: var(--wallet-muted);
  font-size: 14px;
}

.wallet-information-page ::v-deep .all-trade-tab,
.wallet-information-page ::v-deep .v-tabs,
.wallet-information-page ::v-deep .v-tabs-items,
.wallet-information-page ::v-deep .v-window,
.wallet-information-page ::v-deep .v-window__container,
.wallet-information-page ::v-deep .v-window-item {
  background: transparent !important;
}
.wallet-information-page ::v-deep .all-trade-tab > .v-tabs > .v-tabs-bar {
  height: 48px;
  margin-bottom: 18px;
  border-bottom: 1px solid var(--wallet-border);
  background: transparent !important;
}
.wallet-information-page ::v-deep .v-tab {
  min-width: 130px;
  margin-right: 8px;
  border: 1px solid var(--wallet-border) !important;
  border-radius: 6px 6px 0 0;
  background: var(--wallet-panel) !important;
  color: var(--wallet-muted) !important;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}
.wallet-information-page ::v-deep .v-tab--active {
  border-color: var(--wallet-accent) !important;
  background: var(--wallet-accent-soft) !important;
  color: var(--wallet-accent) !important;
}
.wallet-information-page ::v-deep .v-tabs-slider { background: var(--wallet-accent) !important; }

.wallet-information-page ::v-deep .transition-method-card {
  position: relative;
  min-height: 270px;
  height: 100%;
  padding: 20px !important;
  border: 1px solid var(--wallet-border) !important;
  border-radius: 10px !important;
  background: var(--wallet-panel) !important;
  color: var(--wallet-text) !important;
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.wallet-information-page ::v-deep .paymentImage {
  justify-content: flex-start !important;
  gap: 16px;
  width: 100%;
  height: auto !important;
  min-height: 104px;
  margin: 0 !important;
  padding: 40px 0 12px !important;
  background: transparent !important;
}
.wallet-information-page ::v-deep .paymentImage h3 {
  margin: 0;
  color: var(--wallet-text);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.wallet-information-page ::v-deep .paymentImage::before {
  content: "BANK";
  position: absolute;
  top: 18px;
  left: 20px;
  padding: 3px 9px;
  border-radius: 4px;
  background: var(--wallet-accent);
  color: #101010;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.45px;
}
.wallet-information-page ::v-deep .crypto-account-card .paymentImage::before { content: "CRYPTO"; }
.wallet-information-page ::v-deep .wallet-method-icon {
  display: grid !important;
  place-items: center;
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  background: var(--wallet-accent-soft);
}
.wallet-information-page ::v-deep .wallet-method-icon .v-icon {
  color: var(--wallet-accent) !important;
  font-size: 36px;
}
.wallet-information-page ::v-deep .content {
  align-items: stretch;
  gap: 18px;
  padding: 12px 0 18px !important;
  border-bottom: 1px solid var(--wallet-border);
}
.wallet-information-page ::v-deep .content > .v-spacer {
  display: none !important;
}
.wallet-information-page ::v-deep .content .value {
  display: flex !important;
  flex: 1 1 0;
  align-items: flex-start !important;
  min-width: 0;
  width: 50%;
  margin-bottom: 0 !important;
  text-align: left !important;
}
.wallet-information-page ::v-deep .content .value + .value {
  padding-left: 18px;
  border-left: 1px solid var(--wallet-border);
}
.wallet-information-page ::v-deep .content .value > span:first-child {
  display: block;
  width: 100%;
  margin-bottom: 5px;
  color: var(--wallet-muted) !important;
  font-size: 12px;
}
.wallet-information-page ::v-deep .content .value > span:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  width: 100%;
  color: var(--wallet-text) !important;
  font-size: 14px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.wallet-information-page ::v-deep .button-details { padding: 16px 0 0 !important; }
.wallet-information-page ::v-deep .transition-method-card:hover {
  border-color: var(--wallet-accent) !important;
  transform: translateY(-2px);
}
.wallet-information-page ::v-deep .transition-method-card .v-card__title,
.wallet-information-page ::v-deep .transition-method-card .v-card__text,
.wallet-information-page ::v-deep .transition-method-card p,
.wallet-information-page ::v-deep .transition-method-card span {
  color: var(--wallet-text);
}
.wallet-information-page ::v-deep .btn-account {
  min-height: 38px;
  padding: 0 18px !important;
  border: 1px solid var(--wallet-accent) !important;
  border-radius: 6px !important;
  background: var(--wallet-accent) !important;
  color: #101010 !important;
  font-weight: 700;
}
.wallet-information-page ::v-deep .btn-account .v-icon { color: #101010 !important; }
.wallet-information-page ::v-deep .button-details .btn-account {
  width: 100%;
  background: transparent !important;
  color: var(--wallet-accent) !important;
}
.wallet-information-page ::v-deep .button-details .btn-account::after {
  content: "\2192";
  margin-left: 10px;
  font-size: 18px;
}
.wallet-information-page ::v-deep .wallet-information-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 2px 0;
  color: var(--wallet-muted);
  font-size: 13px;
}
.wallet-information-page ::v-deep .wallet-information-footer .v-icon {
  color: var(--wallet-accent) !important;
}
.wallet-information-page ::v-deep .button-details .btn-account:hover {
  background: var(--wallet-accent-soft) !important;
}
.wallet-information-page ::v-deep svg { color: var(--wallet-accent); }

@media (max-width: 600px) {
  .wallet-information-page { height: calc(100dvh - 56px); }
  .wallet-information-container { padding: 18px 14px 32px; }
  .wallet-information-header { align-items: flex-start; }
  .wallet-information-header p { font-size: 12px; }
  .wallet-information-page ::v-deep .all-trade-tab > .v-tabs > .v-tabs-bar { margin-bottom: 12px; }
  .wallet-information-page ::v-deep .v-slide-group__content { justify-content: flex-start; }
  .wallet-information-page ::v-deep .v-tab { min-width: auto; padding: 0 14px; font-size: 12px; }
  .wallet-information-page ::v-deep .transition-method-card { padding: 16px !important; }
  .wallet-information-page ::v-deep .paymentImage::before { left: 16px; }
  .wallet-information-page ::v-deep .content { gap: 10px; }
  .wallet-information-page ::v-deep .content .value + .value { padding-left: 10px; }
}
</style>

<style>
.bank-transfer-details-popup .v-card {
  border: 1px solid #d99a00 !important;
  border-radius: 10px !important;
}
.bank-transfer-details-popup .theme--light.v-card {
  background: #ffffff !important;
  color: #171a1f !important;
}
.theme--dark .bank-transfer-details-popup .v-card,
.bank-transfer-details-popup .theme--dark.v-card {
  border-color: #ffc400 !important;
  background: #07111b !important;
  color: #f4f5f7 !important;
}
.theme--dark .bank-transfer-details-popup .v-card__title,
.theme--dark .bank-transfer-details-popup .v-card__text,
.bank-transfer-details-popup .theme--dark .v-card__title,
.bank-transfer-details-popup .theme--dark .v-card__text { color: #f4f5f7 !important; }
.bank-transfer-details-popup .btn-account {
  border: 1px solid #d99a00 !important;
  border-radius: 6px !important;
  background: #d99a00 !important;
  color: #101010 !important;
  font-weight: 700;
}
.theme--dark .bank-transfer-details-popup .btn-account {
  border-color: #ffc400 !important;
  background: #ffc400 !important;
}
</style>
